import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useMemo, forwardRef } from 'react';
import { StyleSheet, useStyles, text, border, padding, icon } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import { trim } from 'lodash';
var defaultStyles = StyleSheet({
  container: _objectSpread(_objectSpread({
    overflow: 'hidden'
  }, border.styles({
    target: 'avatar'
  })), padding.styles({
    target: 'avatar'
  })),
  containerInteractive: {
    cursor: 'pointer'
  },
  containerSmall: _objectSpread(_objectSpread({}, text.styles({
    target: 'avatar',
    fallback: 'normal.bold'
  })), {}, {
    height: function height(_ref) {
      var token = _ref.token;
      return token('avatar.s.size', '3.2rem');
    },
    width: function width(_ref2) {
      var token = _ref2.token;
      return token('avatar.s.size', '3.2rem');
    }
  }),
  containerMedium: _objectSpread(_objectSpread({}, text.styles({
    target: 'avatar',
    fallback: 'heading.4'
  })), {}, {
    height: function height(_ref3) {
      var token = _ref3.token;
      return token('avatar.m.size', '4rem');
    },
    width: function width(_ref4) {
      var token = _ref4.token;
      return token('avatar.m.size', '4rem');
    }
  }),
  containerLarge: _objectSpread(_objectSpread({}, text.styles({
    target: 'avatar.l',
    fallback: 'heading.2'
  })), {}, {
    height: function height(_ref5) {
      var token = _ref5.token;
      return token('avatar.l.size', '5.6rem');
    },
    width: function width(_ref6) {
      var token = _ref6.token;
      return token('avatar.l.size', '5.6rem');
    }
  }),
  containerRoundedMedium: _objectSpread({}, border.styles({
    target: 'avatar.rounded.m',
    all: {
      radius: 'm'
    }
  })),
  inner: {
    position: 'relative',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    backgroundColor: function backgroundColor(_ref7) {
      var token = _ref7.token;
      return token('avatar.background.color', token('color.container.static.contrast'));
    }
  },
  innerSmall: {
    '& > svg': _objectSpread({}, icon.styles({
      target: 'avatar.s.icon',
      size: 'm'
    }))
  },
  innerMedium: {
    '& > svg': _objectSpread({}, icon.styles({
      target: 'avatar.m.icon',
      size: 'm'
    }))
  },
  innerLarge: {
    '& > svg': _objectSpread({}, icon.styles({
      target: 'avatar.l.icon',
      size: 'xl'
    }))
  },
  innerRoundedMedium: _objectSpread({}, border.styles({
    target: 'avatar.inner.rounded.m',
    all: {
      radius: 's'
    }
  })),
  roundedFull: _objectSpread({}, border.styles({
    target: 'avatar.rounded.full',
    all: {
      radius: 'circle'
    }
  })),
  initials: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: function textTransform(_ref8) {
      var token = _ref8.token;
      return token('avatar.textTransform', 'uppercase');
    }
  },
  image: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    objectFit: 'cover',
    zIndex: 1,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
});
var containerSizes = {
  s: 'containerSmall',
  m: 'containerMedium',
  l: 'containerLarge'
};
var innerSizes = {
  s: 'innerSmall',
  m: 'innerMedium',
  l: 'innerLarge'
};
var containerRadii = {
  m: 'containerRoundedMedium',
  full: 'roundedFull'
};
var innerRadii = {
  m: 'innerRoundedMedium',
  full: 'roundedFull'
};
var iconSizes = {
  s: 'm',
  m: 'm',
  l: 'xl'
};
var displayName = 'Avatar';
/**
 * An avatar is a thumbnail representation of an entity, such as a user or an organization.
 */

export var Avatar = /*#__PURE__*/forwardRef(function (_ref9, ref) {
  var children = _ref9.children,
      style = _ref9.style,
      className = _ref9.className,
      name = _ref9.name,
      src = _ref9.src,
      _ref9$size = _ref9.size,
      size = _ref9$size === void 0 ? 'm' : _ref9$size,
      _ref9$rounded = _ref9.rounded,
      rounded = _ref9$rounded === void 0 ? 'full' : _ref9$rounded,
      onClick = _ref9.onClick,
      Icon = _ref9.Icon,
      props = _objectWithoutProperties(_ref9, ["children", "style", "className", "name", "src", "size", "rounded", "onClick", "Icon"]);

  var s = useStyles(defaultStyles, displayName);
  var initials = useMemo(function () {
    var _name$trim$split, _name$trim, _context2;

    if (!name) {
      return children || '?';
    }

    var nameSplit = name === null || name === void 0 ? void 0 : (_name$trim$split = (_name$trim = _trimInstanceProperty(name).call(name)).split) === null || _name$trim$split === void 0 ? void 0 : _name$trim$split.call(_name$trim, ' ');
    var hyphenSplit = trim(nameSplit[0], '-').split('-');

    if (hyphenSplit.length > 1) {
      var _context;

      return _concatInstanceProperty(_context = "".concat(hyphenSplit[0][0])).call(_context, hyphenSplit[hyphenSplit.length - 1][0]);
    }

    return nameSplit.length === 1 ? nameSplit[0][0] : _concatInstanceProperty(_context2 = "".concat(nameSplit[0][0])).call(_context2, nameSplit[nameSplit.length - 1][0]);
  }, [children, name]);
  return /*#__PURE__*/React.createElement(Box, _extends({}, props, s.with('container', containerSizes[size], containerRadii[rounded], {
    containerInteractive: !!onClick
  })({
    style: style,
    className: className
  }), {
    alignItems: "center",
    justifyContent: "center",
    flex: '0 0 auto',
    ref: ref,
    onClick: onClick
  }), /*#__PURE__*/React.createElement(Box, _extends({}, s('inner', innerSizes[size], innerRadii[rounded]), {
    alignItems: "center",
    justifyContent: "center"
  }), Icon ? /*#__PURE__*/React.createElement(Icon, {
    size: iconSizes[size]
  }) : /*#__PURE__*/React.createElement("span", s('initials'), initials), src && /*#__PURE__*/React.createElement("img", _extends({}, s('image'), {
    src: src,
    alt: name
  }))));
});
Avatar.displayName = displayName;
export default Avatar;